'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import keyMirror from 'react-utils/keyMirror';
import NavMarker from 'react-rhumb/NavMarker';
import Immutable from 'immutable';
import { memoize } from 'underscore';
import GoodFiltersAndPage from '../../constants/GoodFiltersAndPage';
import InitialFilterParams from '../../constants/InitialFilterParams';
import { getPurchaseErrorMessageKey, getPurchaseErrorHeaderKey } from '../../utils/langUtils';
import { getUrlWithNonInitialFiltersAndPageShown } from '../../utils/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIRouterLink from 'ui-addon-react-router/UIRouterLink';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICarousel from 'UIComponents/carousel/UICarousel';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModalDialog from 'UIComponents/dialog/UIModalDialog';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UILink from 'UIComponents/link/UILink';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import UISection from 'UIComponents/section/UISection';
import withPartials from 'marketplace-lib/components/hocs/withPartials';
import GoodInfoCard from './GoodInfoCard';
import GoodRatingInfo from './GoodRatingInfo';
import PackContents from './PackContents';
import TrialBanner from './TrialBanner';
import FilterRouterLink from '../FilterRouterLink';
import PurchaseButtonContainer from '../../containers/PurchaseButtonContainer';
import ReviewListContainer from '../../containers/ReviewListContainer';
import ReviewModalContainer from '../../containers/ReviewModalContainer';
import H2 from 'UIComponents/elements/headings/H2';
var getI18nKey = memoize(function (path) {
  return "MarketplaceUI.goodDetailsPage." + path;
});
var TabIds = Object.freeze(keyMirror({
  DETAILS: null,
  REVIEWS: null
}));
var MAIN_CONTENT_SIZE = 8;

var MainColumn = function MainColumn(props) {
  return React.createElement(UIGridItem, Object.assign({}, props, {
    size: {
      xs: MAIN_CONTENT_SIZE
    }
  }));
};

var SidebarColumn = function SidebarColumn(props) {
  return React.createElement(UIGridItem, Object.assign({}, props, {
    size: {
      xs: 12 - MAIN_CONTENT_SIZE
    }
  }));
};

var GoodDetailsPage = /*#__PURE__*/function (_PureComponent) {
  _inherits(GoodDetailsPage, _PureComponent);

  function GoodDetailsPage(props) {
    var _this;

    _classCallCheck(this, GoodDetailsPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GoodDetailsPage).call(this, props));
    _this.getDefaultFilters = _this.getDefaultFilters.bind(_assertThisInitialized(_this));
    _this.handleTabChange = _this.handleTabChange.bind(_assertThisInitialized(_this));
    _this.handleTriggerReview = _this.handleTriggerReview.bind(_assertThisInitialized(_this));
    _this.state = {
      selectedTabId: TabIds.DETAILS
    };
    return _this;
  }

  _createClass(GoodDetailsPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          canReview = _this$props.canReview,
          navigateFromGoodDetailsReview = _this$props.navigateFromGoodDetailsReview,
          reviewMode = _this$props.reviewMode;

      if (reviewMode) {
        if (canReview) {
          this.handleTriggerReview();
        } else {
          navigateFromGoodDetailsReview();
        }
      }
    }
  }, {
    key: "getDefaultFilters",
    value: function getDefaultFilters() {
      var goodDetails = this.props.goodDetails;
      return InitialFilterParams.merge(_defineProperty({}, GoodFiltersAndPage.SUB_TYPE, goodDetails.get('subType')));
    }
  }, {
    key: "handleTabChange",
    value: function handleTabChange(event) {
      this.setState({
        selectedTabId: event.target.value
      });
    }
  }, {
    key: "handleTriggerReview",
    value: function handleTriggerReview() {
      var _this$props2 = this.props,
          goodDetails = _this$props2.goodDetails,
          triggerReviewModal = _this$props2.triggerReviewModal;
      triggerReviewModal(goodDetails.get('goodId'), goodDetails.get('goodName'), goodDetails.get('transactionId'));
    }
  }, {
    key: "renderBackLink",
    value: function renderBackLink() {
      var _this$props3 = this.props,
          goodFiltersAndPage = _this$props3.goodFiltersAndPage,
          previewMode = _this$props3.previewMode,
          redirectUrl = _this$props3.redirectUrl;
      var Link = redirectUrl ? UILink : UIRouterLink;
      var linkProps = redirectUrl ? {
        href: redirectUrl
      } : {
        to: getUrlWithNonInitialFiltersAndPageShown(goodFiltersAndPage)
      };
      return React.createElement(UIBackButton, {
        className: "integrate-back-to-products"
      }, React.createElement(Link, Object.assign({
        disabled: previewMode
      }, linkProps), React.createElement(FormattedMessage, {
        message: getI18nKey('backLink')
      })));
    }
  }, {
    key: "renderRatingInfo",
    value: function renderRatingInfo() {
      var goodDetails = this.props.goodDetails;
      return React.createElement(GoodRatingInfo, {
        goodDetails: goodDetails
      });
    }
  }, {
    key: "renderProviderInfo",
    value: function renderProviderInfo() {
      var _this$props4 = this.props,
          goodDetails = _this$props4.goodDetails,
          previewMode = _this$props4.previewMode;
      var providerName = goodDetails.get('providerName');
      return React.createElement(FormattedReactMessage, {
        message: getI18nKey('header.provider'),
        options: {
          providerLink: React.createElement(FilterRouterLink, {
            disabled: previewMode,
            filters: InitialFilterParams.merge(_defineProperty({}, GoodFiltersAndPage.PROVIDER, providerName))
          }, providerName)
        }
      });
    }
  }, {
    key: "renderPreviewButton",
    value: function renderPreviewButton() {
      var _this$props5 = this.props,
          goodDetails = _this$props5.goodDetails,
          isCustomModule = _this$props5.isCustomModule,
          partial = _this$props5.partial,
          previewMode = _this$props5.previewMode,
          trackLinkClick = _this$props5.trackLinkClick;

      if (!isCustomModule && goodDetails.get('exampleLink')) {
        return React.createElement(UIButton, {
          disabled: previewMode,
          external: true,
          href: goodDetails.get('exampleLink'),
          onClick: partial(trackLinkClick, 'liveExampleButton'),
          use: "secondary"
        }, React.createElement(FormattedMessage, {
          message: getI18nKey('previewButton.liveExample')
        }));
      }

      return null;
    }
  }, {
    key: "renderPurchaseButton",
    value: function renderPurchaseButton() {
      var _this$props6 = this.props,
          goodNameUrlToken = _this$props6.goodNameUrlToken,
          previewMode = _this$props6.previewMode,
          providerUrlToken = _this$props6.providerUrlToken;
      return React.createElement(PurchaseButtonContainer, {
        goodNameUrlToken: goodNameUrlToken,
        previewMode: previewMode,
        providerUrlToken: providerUrlToken
      });
    }
  }, {
    key: "renderConnectButton",
    value: function renderConnectButton() {
      var goodDetails = this.props.goodDetails;
      return React.createElement(UIButton, {
        className: "purchase-button integrate-purchase-button",
        use: "primary",
        external: true,
        href: goodDetails.get('exampleLink')
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('connectButton.buttonText')
      }));
    }
  }, {
    key: "renderCtaBanner",
    value: function renderCtaBanner() {
      var _this$props7 = this.props,
          canTrialMarketing = _this$props7.canTrialMarketing,
          goodDetails = _this$props7.goodDetails,
          hasPurchaseAccess = _this$props7.hasPurchaseAccess,
          isCustomer = _this$props7.isCustomer,
          partial = _this$props7.partial,
          trackLinkClick = _this$props7.trackLinkClick;

      if (isCustomer && hasPurchaseAccess) {
        return null;
      }

      if (canTrialMarketing || !isCustomer) {
        return React.createElement(TrialBanner, {
          canTrialMarketing: canTrialMarketing,
          isCustomer: isCustomer,
          partial: partial,
          trackLinkClick: trackLinkClick,
          urlToken: goodDetails.get('urlToken')
        });
      }

      return null;
    }
  }, {
    key: "renderInfoCard",
    value: function renderInfoCard() {
      var _this$props8 = this.props,
          goodDetails = _this$props8.goodDetails,
          isCustomModule = _this$props8.isCustomModule,
          isEmailTemplate = _this$props8.isEmailTemplate,
          isPack = _this$props8.isPack,
          isTemplate = _this$props8.isTemplate,
          isTheme = _this$props8.isTheme,
          previewMode = _this$props8.previewMode,
          trackLinkClick = _this$props8.trackLinkClick;
      return React.createElement(GoodInfoCard, {
        defaultFilters: this.getDefaultFilters(),
        goodDetails: goodDetails,
        isCustomModule: isCustomModule,
        isEmailTemplate: isEmailTemplate,
        isPack: isPack,
        isTemplate: isTemplate,
        isTheme: isTheme,
        previewMode: previewMode,
        trackLinkClick: trackLinkClick
      });
    }
  }, {
    key: "renderTabsCard",
    value: function renderTabsCard() {
      var goodDetails = this.props.goodDetails;
      var selectedTabId = this.state.selectedTabId;
      return React.createElement(UICardWrapper, null, React.createElement(UITabs, {
        onSelectedChange: this.handleTabChange,
        selected: selectedTabId
      }, React.createElement(UITab, {
        tabId: TabIds.DETAILS,
        title: React.createElement(FormattedMessage, {
          message: getI18nKey('details.title')
        })
      }, React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: goodDetails.get('description')
        }
      })), React.createElement(UITab, {
        tabId: TabIds.REVIEWS,
        title: this.renderRatingInfo()
      }, React.createElement(ReviewListContainer, {
        triggerReviewModal: this.handleTriggerReview
      }))));
    }
  }, {
    key: "renderTabsSectionContent",
    value: function renderTabsSectionContent() {
      var selectedTabId = this.state.selectedTabId;
      var renderedTabsCard = this.renderTabsCard();

      if (selectedTabId === TabIds.REVIEWS) {
        return renderedTabsCard;
      }

      return React.createElement(UIGrid, null, React.createElement(MainColumn, null, renderedTabsCard), React.createElement(SidebarColumn, null));
    }
  }, {
    key: "renderMainCarouselContent",
    value: function renderMainCarouselContent(props) {
      var className = props.className,
          children = props.children;
      return React.createElement(UICardWrapper, {
        className: className,
        compact: true
      }, children);
    }
  }, {
    key: "renderCarousel",
    value: function renderCarousel() {
      var goodDetails = this.props.goodDetails;
      var moduleImages = goodDetails.get('customModuleImages').toArray();

      if (!moduleImages.length) {
        moduleImages = [goodDetails.get('smallImageUrl')];
      }

      return React.createElement(UICardWrapper, {
        className: "m-bottom-0",
        "data-test-id": "module-image-carousel"
      }, React.createElement(UICardSection, null, React.createElement(UICarousel, {
        className: "p-x-0",
        imageHeight: 360,
        steps: moduleImages.map(function (image, index) {
          return {
            image: image,
            alt: "image-" + index
          };
        }),
        use: "max"
      })));
    }
  }, {
    key: "renderPackContents",
    value: function renderPackContents() {
      var _this$props9 = this.props,
          goodDetails = _this$props9.goodDetails,
          packChildrenSubTypes = _this$props9.packChildrenSubTypes,
          previewMode = _this$props9.previewMode,
          trackLinkClick = _this$props9.trackLinkClick;
      return React.createElement(PackContents, {
        goodDetails: goodDetails,
        packChildrenSubTypes: packChildrenSubTypes,
        previewMode: previewMode,
        trackLinkClick: trackLinkClick
      });
    }
  }, {
    key: "renderTemplateImage",
    value: function renderTemplateImage() {
      var _this$props10 = this.props,
          goodDetails = _this$props10.goodDetails,
          partial = _this$props10.partial,
          previewMode = _this$props10.previewMode,
          trackLinkClick = _this$props10.trackLinkClick;
      var renderedImage = React.createElement(UIImage, {
        className: "integrate-template-image",
        src: goodDetails.get('imageUrl')
      });

      if (!previewMode) {
        renderedImage = React.createElement(UILink, {
          external: true,
          href: goodDetails.get('exampleLink'),
          iconProps: {
            className: 'hidden'
          },
          onClick: partial(trackLinkClick, 'screenshot')
        }, renderedImage);
      }

      return React.createElement("div", {
        className: "template-image-relative-wrapper",
        "data-test-id": "template-image"
      }, React.createElement("div", {
        className: "template-image-container"
      }, renderedImage));
    }
  }, {
    key: "renderMainContent",
    value: function renderMainContent() {
      var _this$props11 = this.props,
          isCustomModule = _this$props11.isCustomModule,
          isPack = _this$props11.isPack,
          isTemplate = _this$props11.isTemplate,
          isTheme = _this$props11.isTheme;

      if (isCustomModule || isTheme) {
        return this.renderCarousel();
      }

      if (isPack) {
        return this.renderPackContents();
      }

      if (isTemplate) {
        return this.renderTemplateImage();
      }

      return null;
    }
  }, {
    key: "renderErrorModalIfPurchaseError",
    value: function renderErrorModalIfPurchaseError() {
      var _this$props12 = this.props,
          goodDetails = _this$props12.goodDetails,
          onClickPurchaseErrorModalClose = _this$props12.onClickPurchaseErrorModalClose;
      return goodDetails.get('purchaseError') && React.createElement(UIModalDialog, {
        width: 350
      }, React.createElement(UIDialogHeader, null, React.createElement(UIDialogCloseButton, {
        onClick: onClickPurchaseErrorModalClose
      }), React.createElement(H2, {
        className: "m-all-0"
      }, React.createElement(FormattedMessage, {
        message: getPurchaseErrorHeaderKey(goodDetails.get('purchaseError'))
      }))), React.createElement(UIDialogBody, null, React.createElement(FormattedMessage, {
        message: getPurchaseErrorMessageKey(goodDetails.get('purchaseError'))
      })), React.createElement(UIDialogFooter, null, React.createElement(UIButton, {
        onClick: onClickPurchaseErrorModalClose,
        use: "primary"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('purchaseErrorModal.button')
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props13 = this.props,
          goodDetails = _this$props13.goodDetails,
          isCustomModule = _this$props13.isCustomModule,
          isPack = _this$props13.isPack,
          isTemplate = _this$props13.isTemplate,
          isTheme = _this$props13.isTheme,
          previewMode = _this$props13.previewMode;
      var containerClasses = classNames('details-container', isCustomModule && 'is--module', isPack && 'is--pack', isTemplate && 'is--template', isTheme && 'is--theme');
      return React.createElement("div", {
        className: "details-page"
      }, React.createElement(NavMarker, {
        name: "DETAIL_PAGE_LOAD"
      }), previewMode && React.createElement(NavMarker, {
        name: "DETAIL_PREVIEW_BANNER_LOAD"
      }, React.createElement(UIAlert, {
        "data-test-id": "preview-mode-banner",
        type: "info"
      }, React.createElement(FormattedMessage, {
        message: getI18nKey('previewModeBanner')
      }))), React.createElement("div", {
        className: containerClasses
      }, goodDetails.get('purchaseInProcess') && React.createElement(UILoadingOverlay, null), React.createElement(UIFlex, {
        className: "page-content-wrapper",
        justify: "center"
      }, React.createElement("div", {
        className: "fixed-page-content"
      }, React.createElement(UISection, null, this.renderBackLink()), React.createElement(UISection, null, React.createElement(UIFlex, {
        align: "baseline",
        justify: "between",
        wrap: "wrap"
      }, React.createElement(UIBox, {
        grow: 1,
        shrink: 1
      }, React.createElement(UIFlex, {
        align: "baseline",
        className: "m-bottom-4"
      }, React.createElement("h4", {
        className: "m-bottom-0"
      }, goodDetails.get('goodName')), this.renderRatingInfo()), this.renderProviderInfo()), React.createElement(UIBox, {
        grow: 0,
        shrink: 0
      }, React.createElement(UIFlex, {
        wrap: "wrap"
      }, this.renderPreviewButton(), React.createElement("div", {
        className: "m-left-2"
      }, this.renderPurchaseButton()))))), this.renderCtaBanner(), React.createElement(UISection, null, React.createElement(UIGrid, null, React.createElement(MainColumn, {
        className: "good-details__main-content"
      }, this.renderMainContent()), React.createElement(SidebarColumn, null, this.renderInfoCard()))), React.createElement(UISection, null, this.renderTabsSectionContent())))), React.createElement(ReviewModalContainer, {
        pageOpenedFrom: "details"
      }), this.renderErrorModalIfPurchaseError());
    }
  }]);

  return GoodDetailsPage;
}(PureComponent);

GoodDetailsPage.propTypes = {
  canReview: PropTypes.bool.isRequired,
  canTrialMarketing: PropTypes.bool.isRequired,
  goodDetails: PropTypes.instanceOf(Immutable.Map).isRequired,
  goodFiltersAndPage: PropTypes.instanceOf(Immutable.Map).isRequired,
  goodNameUrlToken: PropTypes.string.isRequired,
  hasPurchaseAccess: PropTypes.bool.isRequired,
  isCustomModule: PropTypes.bool.isRequired,
  isCustomer: PropTypes.bool.isRequired,
  isEmailTemplate: PropTypes.bool.isRequired,
  isPack: PropTypes.bool.isRequired,
  isTemplate: PropTypes.bool.isRequired,
  isTheme: PropTypes.bool.isRequired,
  navigateFromGoodDetailsReview: PropTypes.func.isRequired,
  onClickPurchaseErrorModalClose: PropTypes.func.isRequired,
  packChildrenSubTypes: PropTypes.arrayOf(PropTypes.string),
  partial: PropTypes.func.isRequired,
  previewMode: PropTypes.bool.isRequired,
  providerUrlToken: PropTypes.string.isRequired,
  reviewMode: PropTypes.bool.isRequired,
  redirectUrl: PropTypes.string,
  trackLinkClick: PropTypes.func.isRequired,
  triggerReviewModal: PropTypes.func.isRequired
};
GoodDetailsPage.defaultProps = {
  previewMode: false,
  reviewMode: false
};
export default withPartials(GoodDetailsPage);